import styled from "styled-components";
import { z } from "zod";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
  fullRoutes,
  hosts,
} from "@songtradr-sso/shared/common";
import {
  redirect,
  staticText as sharedText,
} from "@songtradr-sso/shared/frontend";
import { Divider } from "@songtradr/design-language";
import { staticText } from "../../shared/statics/static-text";
import { Api } from "../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.workspaceCapture,
  shared: { inputs: sharedText.inputs },
};

// STYLES
export const Links = styled.div`
  display: flex;
  flex-flow: column;
  gap: 1rem;

  ${Divider} {
    margin: 0.5rem 0;
  }
`;

// DATA
export const verifyWorkspace = async (workspace: string) => {
  // Verify the workspace exists (will throw if it doesn't)...
  await Api.request({
    method: "POST",
    url: endpoints.workspace,
    data: { workspace },
  });

  // Construct the workspace sign-in URL...
  const url = new URL(`${fullRoutes[App.Core].signIn}`);
  const parts = url.hostname.split(".");
  url.hostname = `${workspace}${hosts.environment === "preview" ? "-" : "."}${parts.join(".")}`;

  // Redirect to the workspace sign-in page...
  await redirect(url.href);
};

// TYPES
export type FormFields = z.infer<typeof schema>;

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].auth;

export const schema = z.object({
  [text.shared.inputs.workspace.id]: z
    .string()
    .min(1, text.shared.inputs.workspace.validation.required)
    .regex(/^[a-z0-9_-]+$/, text.shared.inputs.workspace.validation.noSpecial),
});

// FUNCTIONS

// ASSETS
